import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';

const exportFunc = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.REFRESH.toString()]: () => {
      const newFieldsToRefresh = (action.payload[0] as typeof state.refresh.fieldsToRefresh).filter(
        (newFieldToRefresh) => {
          return !state.refresh.fieldsToRefresh.includes(newFieldToRefresh);
        },
      );

      return {
        ...state,
        refresh: {
          ...state.refresh,
          shouldRefresh: true,
          fieldsToRefresh: [...state.refresh.fieldsToRefresh, ...newFieldsToRefresh],
        },
      };
    },
    [ACTION_TYPES.RESET.toString()]: () => ({
      ...state,
      refresh: {
        ...state.refresh,
        shouldRefresh: false,
        fieldsToRefresh: [],
      },
    }),
  };
};

export default exportFunc;
